import React, { useState, useEffect, useRef } from 'react';
import { Button, MenuItem, Popover, Stack, FormControlLabel, Checkbox, Typography } from '@mui/material';
import { getDecodedToken, getStorage } from '../../service/service';
import useStyles from '../jobs/jobs_styles';
import AnalyticsVisualization from '../framework/analyticsVisualization';
import { dashboardUrl } from '../../service/config';
import { ReactComponent as FilterIcon } from '../../assets/ml_summary_filter.svg';
import './dataGrowth.scss';
import PageWrapper from 'components/Common/PageWraper';
import { useTheme } from "@mui/material/styles";

const databricksDataGrowth = () => {
    interface CheckedList {
        storage: string[];
    }
    const theme = useTheme();

    const userSector = getDecodedToken()?.sector?.name?.toLowerCase();
    const classes = useStyles();
    const dataFetchedRef = useRef(false);
    const [storageOptionsList, setStorageOptionsList] = useState<string[]>([]);
    const [filterMenu, setFilterMenu] = useState<{
        mouseX: number;
        mouseY: number;
    } | null>(null);
    const [itemsChecked, setItemsChecked] = useState(false);
    const [checkedList, setCheckedList] = useState<CheckedList>({
        storage: [],
    });
    const [selectedFilter, setSelectedFilter] = useState<string>('Storage Account');
    const [selectedStorage, setSelectedStorage] = useState<string[]>([]);

    const filterClick = (event: any) => {
        event.preventDefault();
        setFilterMenu(
            filterMenu === null
                ? {
                    mouseX: parseInt(event.clientX) - 20,
                    mouseY: parseInt(event.clientY) - 6
                }
                : null
        );
    };

    const handleClose = () => {
        localStorage.removeItem('presto-summary-sector-filter');
        setCheckedList({
            storage: [],
        });
        setItemsChecked(false);
    };

    const handleMenuItemClick = (filter: string) => {
        setSelectedFilter(filter);
        if (filter === 'Storage Account') {
            setItemsChecked(false);
        }
    };

    useEffect(() => {
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;

        if (userSector === 'all') fetchStorageOptionsData();
        let storedStorageFilter = localStorage.getItem('presto-summary-sector-filter')
            ? JSON.parse(localStorage.getItem('presto-summary-sector-filter') ?? '')
            : null;
        if (storedStorageFilter) {
            setCheckedList(storedStorageFilter);
            setSelectedStorage(storedStorageFilter.storage);
        }
    }, []);

    async function fetchStorageOptionsData() {
        const storageRes = await getStorage('1', '100', '');
        console.log(storageRes)
        if (storageRes.success) {
            setStorageOptionsList(storageRes.data.data.map((x: any) => x));
        }
    }

    const handleOkClick = () => {
        setSelectedStorage(checkedList.storage);
        console.log(checkedList.storage, 'checked list');
        handleViewClose();
    };

    const handleViewClose = () => {
        setFilterMenu(null);
    };

    const handleStorageChange = (updatedSelection: string[]) => {
        setCheckedList((prevState) => ({
            ...prevState,
            storage: updatedSelection
        }));
    };

    const selectAllCheck = (e: any) => {
        const { checked } = e.target;
        setCheckedList((prevState) => ({
            ...prevState,
            storage: checked ? storageOptionsList : []
        }));
        setItemsChecked(checked);
    };



    return (
        <PageWrapper>
            <div className="datagrowth-exexutions-dateFilter-div">
                <Stack>
                    {userSector === "all" ? (
                        <FilterIcon
                            onClick={filterClick}
                            style={{
                                cursor: "pointer",
                                position: "fixed",
                                top: "82px",
                                right: "24px",
                                zIndex: 999,
                            }}
                        />
                    ) : (
                        <Typography sx={{ px: 1 }}>
                            Sector: {getDecodedToken()?.sector?.name}
                        </Typography>
                    )}

                    <Popover
                        open={filterMenu !== null}
                        onClose={handleViewClose}
                        anchorReference="anchorPosition"
                        anchorPosition={
                            filterMenu !== null
                                ? { top: filterMenu.mouseY, left: filterMenu.mouseX }
                                : undefined
                        }
                    >
                        <Stack
                            sx={{
                                backgroundColor: `${theme.palette.dropdown.menuItemBackground} !important`,
                                width: 500,
                                height: 300,
                            }}
                        >
                            {/* Header */}
                            <Stack
                                direction="row"
                                alignItems="center"
                                justifyContent="space-between"
                                sx={{
                                    px: 2,
                                    py: 1,
                                    borderBottom: `1px solid ${theme.palette.dropdown.border}`,
                                }}
                            >
                                <Typography sx={{ color: `${theme.palette.dropdown.menuItemText} !important` }}>
                                    Filters
                                </Typography>
                                <Stack direction="row" spacing={1}>
                                    <Button
                                        variant="contained"
                                        className={classes.cancelBtn}
                                        onClick={handleClose}
                                    >
                                        CLEAR
                                    </Button>
                                    <Button
                                        variant="contained"
                                        className={classes.okBtn}
                                        onClick={handleOkClick}
                                    >
                                        APPLY
                                    </Button>
                                </Stack>
                            </Stack>

                            <Stack direction="row" sx={{ flex: 1 }}>
                                {/* Left side: Filter type list */}
                                <Stack
                                    sx={{
                                        minWidth: 200,
                                        borderRight: `1px solid ${theme.palette.dropdown.border}`,
                                    }}
                                >
                                    {["Storage Account"].map((filter: string) => (
                                        <MenuItem
                                            key={filter}
                                            onClick={() => handleMenuItemClick(filter)}
                                            selected={filter === selectedFilter}
                                            sx={{
                                                color: `${theme.palette.dropdown.menuItemText} !important`,
                                                "&.Mui-selected": {
                                                    backgroundColor: `${theme.palette.dropdown.menuItemSelected} !important`,
                                                    color: `${theme.palette.dropdown.menuItemHoverText} !important`,
                                                },
                                                "&.Mui-selected:hover": {
                                                    backgroundColor: `${theme.palette.dropdown.menuItemHover} !important`,
                                                    color: `${theme.palette.dropdown.menuItemHoverText} !important`,
                                                },
                                                "&:hover": {
                                                    backgroundColor: `${theme.palette.dropdown.menuItemHover} !important`,
                                                    color: `${theme.palette.dropdown.menuItemHoverText} !important`,
                                                },
                                            }}
                                        >
                                            <Typography variant='filterText'>{filter}</Typography>
                                        </MenuItem>
                                    ))}
                                </Stack>

                                {/* Right side: Storage list */}
                                <Stack
                                    sx={{
                                        flex: 1,
                                        maxHeight: 240,
                                        overflowY: "auto",
                                        px: 2,
                                    }}
                                >
                                    {/* Select All */}
                                    <MenuItem disableGutters>
                                        <FormControlLabel
                                            label={
                                                <Typography variant='filterText' sx={{ color: `${theme.palette.dropdown.menuItemText} !important` }}>All</Typography>
                                            }
                                            sx={{
                                                "& .MuiFormControlLabel-label": {
                                                    color: `${theme.palette.dropdown.menuItemText} !important`,
                                                },
                                            }}
                                            control={
                                                <Checkbox
                                                    color="success"
                                                    value="all"
                                                    checked={itemsChecked}
                                                    onChange={(e) => selectAllCheck(e)}
                                                    sx={{
                                                        "& .MuiSvgIcon-root": {
                                                            color: `${theme.palette.dropdown.checkBox} !important`,
                                                        },
                                                    }}
                                                />
                                            }
                                        />
                                    </MenuItem>

                                    {/* Dynamic Storage Options */}
                                    {storageOptionsList &&
                                        storageOptionsList.map((filter: any) => (
                                            <MenuItem key={filter} disableGutters>
                                                <FormControlLabel
                                                    label={
                                                        <Typography variant='filterText' sx={{ color: `${theme.palette.dropdown.menuItemText} !important` }}>{filter}</Typography>
                                                    }
                                                    sx={{
                                                        "& .MuiFormControlLabel-label": {
                                                            color: `${theme.palette.dropdown.menuItemText} !important`,
                                                        },
                                                    }}
                                                    control={
                                                        <Checkbox
                                                            color="success"
                                                            value={filter}
                                                            checked={checkedList.storage.includes(filter)}
                                                            onChange={() => {
                                                                const updatedSelection = checkedList.storage.includes(
                                                                    filter
                                                                )
                                                                    ? checkedList.storage.filter((item) => item !== filter)
                                                                    : [...checkedList.storage, filter];
                                                                handleStorageChange(updatedSelection);
                                                            }}
                                                            sx={{
                                                                "& .MuiSvgIcon-root": {
                                                                    color: `${theme.palette.dropdown.checkBox} !important`,
                                                                },
                                                            }}
                                                        />
                                                    }
                                                />
                                            </MenuItem>
                                        ))}
                                </Stack>
                            </Stack>
                        </Stack>
                    </Popover>
                </Stack>

                <AnalyticsVisualization
                    params={{
                        dashboardUrl: dashboardUrl.dataGrowthDataBricksTotalCountOfTables,
                        className: 'dataGrowthDatabricksframeContainer',
                        otherParams: {
                            'var-storageAccount': selectedStorage,
                        },
                        seamless: true
                    }}
                />
                <AnalyticsVisualization
                    params={{
                        dashboardUrl: dashboardUrl.dataGrowthDataBricksTotalSizeOfTables,
                        className: 'dataGrowthDatabricksTableSizeframeContainer',
                        otherParams: {
                            'var-storageAccount': selectedStorage,
                        },
                        seamless: true
                    }}
                />
            </div>
        </PageWrapper>
    );
};

export default databricksDataGrowth;
